import React, { useCallback, useState, createContext, useContext } from 'react';
import { ContactModal, ModalVariant } from './ContactModal';
import { reachGoal } from '../utils/metrika';
interface ContextValue {
  openModal: (variant: ModalVariant) => void;
}
const ContactModalContext = createContext<ContextValue | null>(null);
export const useContactModal = () => {
  const ctx = useContext(ContactModalContext);
  if (!ctx) throw new Error('useContactModal must be used within ContactModalProvider');
  return ctx;
};
export const ContactModalProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [variant, setVariant] = useState<ModalVariant | null>(null);
  const openModal = useCallback((v: ModalVariant) => {
    reachGoal('open_form', {
      form_variant: v
    });
    setVariant(v);
  }, []);
  return <ContactModalContext.Provider value={{
    openModal
  }} data-id="element-37">
      {children}
      <ContactModal variant={variant} onClose={() => setVariant(null)} data-id="element-38" />
    </ContactModalContext.Provider>;
};